import { render } from "./Footer.vue?vue&type=template&id=2299361a&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2299361a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/yohom_cp/yohom_cp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2299361a"]])

export default __exports__